import { useEffect, useState } from "react";
import { hasQuiz } from "../utils/content-blocks-utils";

export function useAdvanceControl({
  contentBlocksGroups,
  currentBlocksGroupIndex,
  shouldRequireScroll = false,
  hasScrolledToBottom = true,
}: {
  contentBlocksGroups: Array<{ content: ContentBlock[] }>;
  currentBlocksGroupIndex: number;
  shouldRequireScroll?: boolean;
  hasScrolledToBottom?: boolean;
}) {
  const [canAdvance, setCanAdvance] = useState(true);

  useEffect(() => {
    // If scroll requirement is enabled, check if user scrolled to bottom
    if (shouldRequireScroll) {
      setCanAdvance(hasScrolledToBottom);
      return;
    }

    // Original logic: check for quizzes
    if (!hasQuiz(contentBlocksGroups)) {
      setCanAdvance(true);
    }
  }, [currentBlocksGroupIndex, contentBlocksGroups, shouldRequireScroll, hasScrolledToBottom]);

  return { canAdvance, setCanAdvance };
}
